import {
  APP_SETTING_DELETE_SNIPPET_SNAPSHOT_BEGIN,
  APP_SETTING_DELETE_SNIPPET_SNAPSHOT_SUCCESS,
  APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE,
  APP_SETTING_DELETE_SNIPPET_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteSnippetSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_SNIPPET_SNAPSHOT_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/snippet-snapshots/${uuid}`,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_DELETE_SNIPPET_SNAPSHOT_SUCCESS,
              data: args.uuid,
            });
            toast.success('Snippet Snapshot Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteSnippetSnapshotError() {
  return {
    type: APP_SETTING_DELETE_SNIPPET_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_SNIPPET_SNAPSHOT_BEGIN:
      return {
        ...state,
        deleteSnippetSnapshotPending: true,
        deleteSnippetSnapshotError: null,
      };

    case APP_SETTING_DELETE_SNIPPET_SNAPSHOT_SUCCESS:
      return {
        ...state,
        deleteSnippetSnapshotPending: false,
        deleteSnippetSnapshotError: null,
        snippetSnapshots: state.snippetSnapshots.filter((e) => e.uuid !== action.data),
      };

    case APP_SETTING_DELETE_SNIPPET_SNAPSHOT_FAILURE:
      return {
        ...state,
        deleteSnippetSnapshotPending: false,
        deleteSnippetSnapshotError: action.data.error,
      };

    case APP_SETTING_DELETE_SNIPPET_SNAPSHOT_DISMISS_ERROR:
      return {
        ...state,
        deleteSnippetSnapshotError: null,
      };

    default:
      return state;
  }
}
